// =============================================================================
// Shared Kapio design tokens — canonical color palette + shadows + font.
// Single source of truth for all four apps. Each app re-exports from here
// and may extend with app-specific tokens (e.g. desktop SHADOWS).
//
// EXACT hex values from Kapio_App.jsx — do NOT substitute Tailwind defaults
// or "close enough" alternatives.
// =============================================================================

export const C = {
  // ── Greens — primary brand palette ─────────────────────────────────────
  hunter:   "#3A5A40",
  hunterDk: "#2D4A34",
  hunterLt: "#4A7A52",

  // ── Neutrals ──────────────────────────────────────────────────────────
  dust:     "#DAD7CD",
  dustLt:   "#E8E6DE",
  dustDk:   "#C4C1B7",
  cream:    "#F5F3EE",
  white:    "#FFFFFF",
  charcoal: "#1C1C1C",
  slate:    "#4A4A4A",
  muted:    "#7A7A6C",
  bg:       "#FAFAF7",

  // ── Semantic — error / destructive ─────────────────────────────────────
  red:      "#EF4444",
  redBg:    "#FEF2F2",
  redLt:    "#FF6B6B",
  redDk:    "#7F1D1D",
  redText:  "#B91C1C",
  redBorder:"#FECACA",

  // ── Semantic — success / selected ──────────────────────────────────────
  greenBg:  "#E8F0E9",
  greenDk:  "#166534",
  greenLt:  "#A3C45A",

  // ── Semantic — warning ─────────────────────────────────────────────────
  amber:    "#F59E0B",
  amberBg:  "#FFF8E1",
  amberDk:  "#92400E",
  amberBorder:"#FDE68A",

  // ── Semantic — info ────────────────────────────────────────────────────
  blue:     "#3B82F6",
  blueBg:   "#EFF6FF",
  blueDk:   "#1E40AF",

  // ── Semantic — pending / processing (payout flow) ──────────────────────
  pendingBg:     "#FEF8E1",
  pendingBorder: "#F0E4A6",
};

export const SHADOWS = {
  card:  "0 2px 12px rgba(0, 0, 0, 0.03)",
  float: "0 4px 16px rgba(0, 0, 0, 0.10)",
  nav:   "0 4px 30px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04)",
  cta:   "0 4px 16px rgba(58, 90, 64, 0.2)",
  fab:   "0 4px 12px rgba(58, 90, 64, 0.3)",
};

export const FONT = "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
